module.exports = ReactDOM;


/*****************
 ** WEBPACK FOOTER
 ** external "ReactDOM"
 ** module id = 91
 ** module chunks = 0
 **/